var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { MessageModifiers } from "../../data";
import { InstantCollapsible } from "sb-resp-ui";
import { TypeExtends } from "sb-js-extends";
TypeExtends();
import { BetPlacementStatus } from "./data";
import * as SCMP from "../../components";
import * as CMP from "./components";
let PulseBetMarkets = class PulseBetMarkets extends React.Component {
    constructor(props) {
        super(props);
        // setup dictionary
        this.dict = this.props.dict;
        this.countDownValues = ["3", "2", "1", this.dict.GoLabel];
        // setup data provider
        this.state = {
            dataProvider: this.props.dataProvider
        };
    }
    // A check needed to show which component should be rendered
    renderPulseBetContainer(pulseBetMarket) {
        return (React.createElement("div", { className: "rj-pulse-bet-market__collapsible-wrap", key: `${pulseBetMarket.pulseBetMetadata.name}` },
            React.createElement(InstantCollapsible, { trigger: React.createElement(SCMP.Heading, { label: pulseBetMarket.pulseBetMetadata.name, isDesktop: this.state.dataProvider.deviceDetect.isDesktop, tooltipMessage: this.dict[`Branch${pulseBetMarket.pulseBetMetadata.branchID}_${pulseBetMarket.pulseBetMetadata.typeId}_`] }), content: React.createElement("div", { className: "rj-pulse-bet-market-main-container" }, this.state.dataProvider.eventsBetPlacementResult.map(data => pulseBetMarket.pulseBetMetadata.marketId === data.eventId &&
                    this.renderMarket(data, pulseBetMarket))), initiallyExpanded: true })));
    }
    renderPulseContent(pulseBetMarket, betPlacementData) {
        let isDisabled = this.state.dataProvider.isDanger || pulseBetMarket.pulseBetMetadata.isDanger;
        return (React.createElement("div", { className: "rj-pulse-bet-markets", "data-suspended": isDisabled },
            React.createElement(SCMP.Winnings, { inputData: pulseBetMarket.winings }),
            React.createElement(CMP.TimePeriod, { periodFrames: pulseBetMarket.periodFrames.map(period => `${period} ${this.state.dataProvider.addSuffix(pulseBetMarket.pulseBetMetadata.marketId)}`) }),
            React.createElement("div", { className: "rj-pulse-bet-markets__pre-bet" },
                React.createElement(SCMP.SlimProgressbar, { eventID: pulseBetMarket.pulseBetMetadata.marketId })),
            React.createElement("div", { className: "rj-pulse-bet-markets__btns-holder" },
                React.createElement("div", { className: "rj-my-pulse-bets__btn-outer", hidden: !pulseBetMarket.freeBetsEnabled },
                    React.createElement(CMP.Dropdown, { data: pulseBetMarket.freeBetOptions, selectItem: pulseBetMarket.onFreePulseBetSelect, blockName: "pulse-bet", defaultText: this.dict.SelectFreeBet })),
                React.createElement("div", { className: "rj-my-pulse-bets__btn-outer", hidden: pulseBetMarket.freeBetsEnabled },
                    React.createElement(CMP.StakeHolder, { data: this.state.dataProvider.stakeInputDataView(pulseBetMarket.pulseBetMetadata.marketId) })),
                React.createElement("div", { className: "rj-my-pulse-bets__pulse-btn-outer" }, this.renderPulseBetButton(pulseBetMarket, isDisabled))),
            React.createElement(CMP.FreeBet, { isActive: pulseBetMarket.hasFreeBetOptions, text: this.state.dataProvider.stakeTypeText(pulseBetMarket.pulseBetMetadata.typeId), toggleStakeType: pulseBetMarket.toggleStakeType }),
            React.createElement("div", { className: "rj-pulse-bet-markets__messages" },
                betPlacementData.status === BetPlacementStatus.Error && React.createElement(CMP.ErrorMessage, { error: betPlacementData.error }),
                this.state.dataProvider.isUserLogged &&
                    this.state.dataProvider.userInfo.TaxProvider && !!this.state.dataProvider.userInfo.TaxProvider.TaxInfo.CountryTax &&
                    React.createElement(CMP.GeneralMessage, { text: this.dict.GermanTaxesMessage.format(this.state.dataProvider.userInfo.TaxProvider.TaxInfo.CountryTax), modifier: MessageModifiers.Tax }))));
    }
    renderPulseBetButton(pulseBetMarket, isDisabled) {
        return (React.createElement(SCMP.PulseBetButton, { handler: pulseBetMarket.externalPlaceBetHandler, isDisabled: isDisabled || !this.state.dataProvider.isUserGeolocated || this.state.dataProvider.isPlacingBetsDisabled || (this.state.dataProvider.IsSeamlessOrWallet() && !this.state.dataProvider.isUserLogged) }, this.state.dataProvider.placeButtonText(pulseBetMarket.pulseBetMetadata.typeId)));
    }
    getInfoMessages() {
        return this.state.dataProvider.store.infoMessages.map(x => React.createElement(CMP.GeneralMessage, { text: x }));
    }
    renderAcceptedBetMessage(betPlacementData) {
        return (React.createElement("div", { className: "rj-pulse-bet-markets__success" },
            React.createElement(CMP.AcceptedBet, { data: betPlacementData.success }),
            this.getInfoMessages()));
    }
    renderProcessBetMessage() {
        return (React.createElement("div", { className: "rj-pulse-bet-markets__in-process" },
            React.createElement(CMP.PulseLoading, null),
            this.getInfoMessages()));
    }
    renderMarket(betPlacementData, pulseBetMarket) {
        return (React.createElement(React.Fragment, { key: `${pulseBetMarket.pulseBetMetadata.marketId}` }, this.renderPulseBetMarketView(pulseBetMarket, betPlacementData)));
    }
    renderPulseBetMarketView(pulseBetMarket, betPlacementData) {
        switch (betPlacementData.status) {
            case BetPlacementStatus.InProcess:
                return this.renderProcessBetMessage();
            case BetPlacementStatus.Success:
                return this.renderAcceptedBetMessage(betPlacementData);
            case BetPlacementStatus.Error:
            case BetPlacementStatus.NotStarted:
            default:
                return this.renderPulseContent(pulseBetMarket, betPlacementData);
        }
    }
    render() {
        return (React.createElement(React.Fragment, null, this.state.dataProvider.store.pulsebetsDataForComponents.map((data) => this.renderPulseBetContainer(data))));
    }
};
PulseBetMarkets = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], PulseBetMarkets);
export { PulseBetMarkets };
//# sourceMappingURL=PulseBetMarkets.js.map